"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var eCommerce_1 = require("../../../utils/eCommerce");
var BaseComponent_1 = require("../../../BaseComponent");
var HegydCore_1 = require("../../../components/hegyd/hegyd-core/HegydCore");
var $ = require("jquery");
var refreshHeaderShopName_1 = require("../../../utils/refreshHeaderShopName");
var Product = /** @class */ (function (_super) {
    __extends(Product, _super);
    function Product($view) {
        var _this = _super.call(this, $view) || this;
        _this.bind();
        return _this;
    }
    Product.prototype.bind = function () {
        this.initEvents();
        this.hideLoader();
        this.initSlick();
        this.thumbnailsCarousel();
    };
    Product.prototype.getSelectorInputQuantity = function () {
        return "input[name='product-count']";
    };
    Product.prototype.getSelectorLinkFavorite = function () {
        return 'a.add-fav';
    };
    Product.prototype.getSelectorDecli = function () {
        return '.product-infos select#variant-select';
    };
    Product.prototype.getElementInputQuantity = function () {
        return $(this.getSelectorInputQuantity());
    };
    Product.prototype.getElementLinkFavorite = function () {
        return $(this.getSelectorLinkFavorite());
    };
    Product.prototype.getRouteLinkFavorite = function () {
        return this.getElementLinkFavorite().attr('href');
    };
    Product.prototype.getElementLoaderBlock = function () {
        return $('.bloc-loader');
    };
    Product.prototype.getSelectorCtaContainer = function () {
        return $('.product-infos .product-form-cta');
    };
    Product.prototype.getSelectorAddCart = function () {
        return '.product-infos .btn-add-cart';
    };
    Product.prototype.getSelectorUpQuantity = function () {
        return '.product-infos .stepper-input .controls button.btn-left';
    };
    Product.prototype.getSelectorDownQuantity = function () {
        return '.product-infos .stepper-input .controls button.btn-right';
    };
    Product.prototype.getElementProductInfo = function () {
        return $('#product_infos_wrapper');
    };
    Product.prototype.getElementSelecteurDecli = function () {
        return $('#variant-select');
    };
    Product.prototype.getSelectorColorModel = function () {
        return '.product-infos .colors-models a';
    };
    Product.prototype.getSelectorSizeModel = function () {
        return '.product-infos .size-contain a';
    };
    Product.prototype.getSelectorSelectColorModel = function () {
        return '.product-infos select[name="color"]';
    };
    Product.prototype.getSelectorSelectSizeModel = function () {
        return '.product-infos select[name="size"]';
    };
    Product.prototype.getSelectorBackToStock = function () {
        return '.product-infos #send-mail-stock';
    };
    Product.prototype.getSelectorTabReviews = function () {
        return '.tab-reviews';
    };
    Product.prototype.getGoToReviewsSelector = function () {
        return '.go-to-reviews';
    };
    Product.prototype.getReviewsPaginateSelector = function () {
        return '#Reviews .pagination a';
    };
    Product.prototype.displayLoader = function () {
        this.getElementLoaderBlock().removeClass('hide');
    };
    Product.prototype.hideLoader = function () {
        this.getElementLoaderBlock().addClass('hide');
    };
    Product.prototype.getCartQuantity = function () {
        return parseInt(this.getElementInputQuantity().val().toString());
    };
    Product.prototype.getUrlProductInfo = function () {
        return this.getElementProductInfo().data('route_product_info');
    };
    Product.prototype.getProductId = function () {
        return this.getSelectorCtaContainer().data('product_id');
    };
    Product.prototype.getProductParentId = function () {
        return this.getSelectorCtaContainer().data('product_parent_id');
    };
    Product.prototype.replaceModalContent = function (data) {
        $('#modal').addClass('confirm');
        $('#modal .modal-content').html(data);
        this.removeModalClassOnClose('confirm');
    };
    Product.prototype.removeModalClassOnClose = function ($class) {
        $('#modal').on('hidden.bs.modal', function () {
            $('#modal').removeClass($class);
        });
    };
    Product.prototype.sendRequestRefreshInfosView = function () {
        var _this = this;
        this.displayLoader();
        HegydCore_1.default.sendRequest(this.getUrlProductInfo(), 'GET', {
            product_id: this.getProductId()
        }, function (data) { return _this.refreshInfosView(data); });
    };
    Product.prototype.getSelectorSelectsFeatures = function () {
        return '#container-select-features select';
    };
    Product.prototype.getElementSelectsFeatures = function () {
        return $(this.getSelectorSelectsFeatures());
    };
    Product.prototype.getRouteChooseProductFromFeature = function () {
        return $('#container-select-features').data('route');
    };
    Product.prototype.refreshInfosView = function (data) {
        if (data) {
            if (data.without_photo) {
                $('.product-infos-right').empty().html(data.product_view.product_infos_general);
                $('#technicals_informations_container').empty().html(data.product_view.product_infos_technical);
            }
            else {
                this.getElementProductInfo().empty().html(data.product_view);
            }
            this.initPlugins();
            this.hideLoader();
        }
    };
    Product.prototype.addToCart = function ($element) {
        var _this = this;
        HegydCore_1.default.sendRequest($element.attr('data-href'), 'POST', {
            product_id: this.getProductId(),
            quantity: this.getCartQuantity(),
            return_templates: ['cart-header']
        }, function (data) {
            if (data.open_store_locator) {
                HegydCore_1.default.initRemoteModal('#modal-store', $element.attr('data-modal-href'), null, function (cbData) {
                    if (cbData.shop_name) {
                        refreshHeaderShopName_1.default(cbData.shop_name);
                    }
                    _this.addToCart($element);
                });
            }
            else {
                eCommerce_1.default(data);
                if (data.product_added_with_success) {
                    if (data.modal && (typeof $('#modal') !== 'undefined')) {
                        _this.replaceModalContent(data.modal);
                        if (!$('#modal').hasClass('show')) {
                            $('#modal').modal('show');
                        }
                    }
                    else {
                        // @ts-ignore
                        Kernel.factories.Toaster($('html'), 'success', data.message);
                    }
                }
                else {
                    // @ts-ignore
                    Kernel.factories.Toaster($('html'), 'error', data.message);
                }
            }
        });
    };
    Product.prototype.updateQuantity = function ($element, $operation) {
        var $el = this.getElementInputQuantity();
        var max = parseInt($el.attr('max'));
        var val = parseInt($el.val());
        if ($operation === "+") {
            val = val + 1;
        }
        else {
            if (val > 1) {
                val = val - 1;
            }
        }
        if (val <= max) {
            this.getElementInputQuantity().val(val);
        }
        this.getElementInputQuantity().trigger('change');
    };
    Product.prototype.toggleFavoris = function () {
        var _this = this;
        HegydCore_1.default.sendRequest(this.getRouteLinkFavorite(), 'PUT', {}, function (data) {
            // @ts-ignore
            Kernel.factories.Toaster($('html'), 'success', data.message);
            _this.sendRequestRefreshInfosView();
        });
    };
    Product.prototype.getInfosFromFeatures = function (without_photo) {
        var _this = this;
        if (without_photo === void 0) { without_photo = false; }
        var features = {};
        this.getElementSelectsFeatures().each(function () {
            features[$(this).data('feature_id')] = $(this).val();
        });
        HegydCore_1.default.sendRequest(this.getRouteChooseProductFromFeature(), 'POST', {
            parent_id: this.getProductParentId(),
            features: features,
            without_photo: without_photo ? 1 : 0
        }, function (data) {
            _this.refreshInfosView(data);
            _this.initSlick();
            _this.thumbnailsCarousel();
            // @ts-ignore
            Kernel.factories.ProductCard($('.slider-item.vproduct'));
        });
    };
    Product.prototype.initPlugins = function () {
        // @ts-ignore
        Kernel.factories.CustomSelectVariant(this.$view);
        // @ts-ignore
        Kernel.factories.ProductImagePhotoswipe(this.$view);
        $('.product-form-select select').each(function () {
            // @ts-ignore
            Kernel.factories.CustomSelect($(this));
        });
    };
    Product.prototype.loadReviews = function (requestUrl) {
        if ($('#Reviews').children().length === 0) {
            HegydCore_1.default.sendRequest(requestUrl, 'GET', null, function (data) {
                $('#Reviews').html(data);
            });
        }
    };
    Product.prototype.initSlick = function () {
        // @ts-ignore
        $('.slider-product').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 2,
            prevArrow: '<button class="arrow-btn prev-arrow"></button>',
            nextArrow: '<button class="arrow-btn next-arrow"></button>',
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    };
    Product.prototype.thumbnailsCarousel = function () {
        // @ts-ignore
        $('.img-gallery').slick({
            speed: 300,
            slidesToShow: 6,
            slidesToScroll: 1,
            vertical: true,
            prevArrow: '<button class="arrow-btn prev-arrow"></button>',
            nextArrow: '<button class="arrow-btn next-arrow"></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 5,
                    }
                },
                {
                    breakpoint: 620,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 495,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 375,
                    settings: {
                        slidesToShow: 2,
                    }
                },
            ]
        });
    };
    Product.prototype.initEvents = function () {
        var _this = this;
        //Click sur le boutton d'ajout au panier
        this.$view.on('click', this.getSelectorAddCart(), function (e) {
            e.preventDefault();
            _this.addToCart($(e.target).closest(_this.getSelectorAddCart()));
        });
        //Changement sur le selecteur de déclinaisons
        this.$view.on('change', this.getSelectorDecli(), function (e) {
            _this.displayLoader();
            HegydCore_1.default.sendRequest(_this.getUrlProductInfo(), 'GET', {
                product_id: $(e.target).val()
            }, function (data) { return _this.refreshInfosView(data); });
        });
        //Click sur le boutton d'ajout aux favoris
        this.$view.on('click', this.getSelectorLinkFavorite(), function (e) {
            e.preventDefault();
            _this.toggleFavoris();
        });
        /* Quantité flech up */
        this.$view.on('click', this.getSelectorUpQuantity(), function (e) {
            e.preventDefault();
            _this.updateQuantity($(e.target).closest(_this.getSelectorUpQuantity()), '+');
        });
        /* Quantité flech down */
        this.$view.on('click', this.getSelectorDownQuantity(), function (e) {
            e.preventDefault();
            _this.updateQuantity($(e.target).closest(_this.getSelectorDownQuantity()), '-');
        });
        /*Change select value color*/
        this.$view.on('click', this.getSelectorColorModel(), function (e) {
            e.preventDefault();
            var new_val = $(e.target).closest(_this.getSelectorColorModel()).attr('class');
            new_val = new_val.replace('active', '').replace('disabled', '').trim();
            _this.$view.find(_this.getSelectorSelectColorModel()).val(new_val);
            _this.getInfosFromFeatures();
        });
        /*Change select value size*/
        this.$view.on('click', this.getSelectorSizeModel(), function (e) {
            e.preventDefault();
            var new_val = $(e.target).closest(_this.getSelectorSizeModel()).data('size');
            _this.$view.find(_this.getSelectorSelectSizeModel()).val(new_val);
            _this.getInfosFromFeatures(true);
        });
        /* Inscription mail retour de stock */
        this.$view.on('click', this.getSelectorBackToStock(), function (e) {
            e.preventDefault();
            HegydCore_1.default.sendRequest($(e.target).attr('href'), 'GET', {
                id: $(e.target).data('product_id'),
                email: $('#email-client').val()
            }, function (data) {
                // @ts-ignore
                Kernel.factories.Toaster($('html'), 'success', data.message);
            });
            e.stopPropagation();
        });
        this.$view.on('click', ".product-description a", function (e) {
            e.preventDefault();
            $([document.documentElement, document.body]).animate({
                scrollTop: $("#Technical").offset().top - 280
            }, 700);
        });
        this.$view.on('click', this.getSelectorTabReviews(), function (e) {
            _this.loadReviews($(e.target).data('load'));
        });
        this.$view.on('click', this.getGoToReviewsSelector(), function () {
            _this.loadReviews($(_this.getSelectorTabReviews()).data('load'));
            $(_this.getSelectorTabReviews()).tab('show');
        });
        this.$view.on('click', this.getReviewsPaginateSelector(), function (e) {
            e.preventDefault();
            HegydCore_1.default.sendRequest($(e.target).attr('href'), 'GET', null, function (data) {
                $('#Reviews').html(data);
            });
        });
    };
    return Product;
}(BaseComponent_1.default));
exports.default = Product;
;
